export const uniqueBy = <T>(
  list: T[],
  field: (item: T) => string | number,
): T[] => {
  const seen = new Set<string | number>();

  return list.filter((item) => {
    const key = field(item);

    if (seen.has(key)) return false;
    seen.add(key);

    return true;
  });
};
